<app-loading-header></app-loading-header>

<div class="container ecomm-bck" style="min-height: 770px;">
    <div class="main-wrap">
        <div class="ecomm-hd">
            <div class="backstep" style="cursor: pointer;">

                <div class="left" style="text-align: center;">

                    <div class="text w-100 loading-animate" style="width: 50%;"></div>
                </div>
                <div class="right" style="padding-left: 400px;">

                    <div class="text w-100 loading-animate" style="width: 100%;"></div>
                </div>
            </div>
        </div>
        <div id="infopax">
            <aside>
                <img src="assets/resource_loading/loading-boat.gif" alt="">
                <div class="tourdet" ng-reflect-ng-style="[object Object]" style="color: rgb(51, 122, 183);">

                    <div class="left">

                        <div class="text w-100 loading-animate"></div>


                    </div>
                    <div class="right">

                        <div class="avatar w-100 loading-animate" style="margin-left: 94px; height: 34px;"></div>
                    </div>
                </div>
                <table width="100%">
                    <tbody>
                        <tr>
                            <th colspan="2" scope="col">Travel Dates</th>
                        </tr>
                        <tr>
                            <td><strong>  <div class="text w-100 loading-animate"></div></strong></td>
                            <td>

                                <div class="text w-100 loading-animate"></div>

                            </td>
                        </tr>
                        <tr>
                            <td><strong>  <div class="text w-100 loading-animate"></div></strong></td>
                            <td>
                                <div class="text w-100 loading-animate"></div>
                            </td>
                        </tr>
                        <tr>
                            <th colspan="2" scope="col">Tour Details</th>
                        </tr>
                        <tr>
                            <td><strong>  <div class="text w-100 loading-animate"></div></strong></td>
                            <td>
                                <div class="text w-100 loading-animate"></div>
                            </td>
                        </tr>
                        <tr>
                            <td><span><strong >  <div class="text w-100 loading-animate"></div></strong></span></td>


                            <td class="ng-star-inserted">
                                <div class="text w-100 loading-animate"></div>
                            </td>

                        </tr>
                        <tr class="ng-star-inserted">
                            <th colspan="2" scope="col">Aditional Services</th>
                        </tr>


                        <tr class="ng-star-inserted">
                            <td colspan="2"><small> <div class="text w-100 loading-animate"></div></small></td>
                        </tr>
                        <tr class="ng-star-inserted">
                            <td colspan="2"><small> <div class="text w-100 loading-animate"></div> </small></td>
                        </tr>
                        <tr class="ng-star-inserted">
                            <td colspan="2"><small> <div class="text w-100 loading-animate"></div> </small></td>
                        </tr>
                    </tbody>
                </table><br>
                <table border="1" id="tShare" width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <a class="shareDate">
                                    <div class="text w-100 loading-animate"></div>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </aside>
            <div class="modules-ecomm">

                <div class="ng-star-inserted">
                    <div class="headmod" ng-reflect-ng-style="[object Object]" style="background-color: rgb(51, 122, 183); display: flex; flex-direction: column;">
                        <div class="text w-100 loading-animate" style="width: 50%;"></div>
                    </div>
                    <div class="mod-content active">

                        <div id="no-more-tables" class="ng-star-inserted">


                            <div class="ng-star-inserted">

                                <div class="avatar w-100 loading-animate" style="height: 418px; width: 100%;"></div>

                            </div>
                            <p style="text-align: center; margin-top: 30px;"><em>
                                 
                                  Certain filters and security settings may prevent our emails (responses) from arriving in your inbox so please be sure to check your junk, trash or spam folders.</em></p>
                        </div>


                    </div>


                </div>
            </div><br></div>
    </div>
</div>